import * as Yup from "yup";

import { variables } from "../../Variables";

const { required } = variables;

export const addvalidation = Yup.object({
  name: Yup.string()
  .required("Please enter the required field")
  .matches(/^[aA-zZ\s]+$/, "Only alphabets are allowed for this field ")
});
